import { useState } from "react";
import "./styles/faq.scss";
import Faqcpa from "./component/faqcpa";
import Faqcma from "./component/faqcma";
import Faqea from "./component/faqea";
import Faqcia from "./component/faqcia";
import { useSearchParams } from "react-router-dom";

function Faq() {
  const [searchParams] = useSearchParams();
  const defaultTab = searchParams.get("tab") || "cpa";
  const [selectedComponent, setSelectedComponent] = useState(defaultTab);

  return (
    <>
      <div className="banner">
        <img src="./faqImg/faq.jpg" alt="FAQ Banner" />
        <div className="bannerttitle dis">FAQ</div>
      </div>

      <div className="faq">
        <div className="faqsubnav col-3">
          <div className="faqcpa" onClick={() => setSelectedComponent("cpa")}>
            CPA<br />
            <div className="fs-2">常見問題</div>
          </div>
          <div className="faqcma" onClick={() => setSelectedComponent("cma")}>
            CMA<br />
            <div className="fs-2">常見問題</div>
          </div>
          <div className="faqea" onClick={() => setSelectedComponent("ea")}>
            EA<br />
            <div className="fs-2">常見問題</div>
          </div>
          <div className="faqcia" onClick={() => setSelectedComponent("cia")}>
            CIA<br />
            <div className="fs-2">常見問題</div>
          </div>
        </div>

        <div className="col-9 mt-5 mb-5 questionarea">
          <div className="question">
            {selectedComponent === "cpa" && <Faqcpa />}
            {selectedComponent === "cma" && <Faqcma />}
            {selectedComponent === "ea" && <Faqea />}
            {selectedComponent === "cia" && <Faqcia />}
          </div>
        </div>
      </div>
    </>
  );
}
export default Faq;
